import { A } from '@adornis/base/env-info.js';
import type { Dictionary, Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import type { Filter } from 'mongodb';
import { ZipCity } from '../adresse.js';
import type { KPF } from '../master-data-management/kpf/entities/KPF.js';

/**
 * @entity KpfFilter
 */
@Entity()
export class KpfFilter extends AdornisFilter {
  public static override _class = 'KpfFilter';

  constructor(doc: PartialEntityData<KpfFilter>) {
    super(doc);
  }

  // Only used to check if a filter has been changed to a new one
  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  public _id!: string;

  @Field(() => [String])
  public ids: Maybe<string[]>;

  @Field(() => [String])
  public partnerIds: Maybe<string[]>;

  @Field(() => [ZipCity])
  public zipCities?: ZipCity[];

  @Field(() => [String])
  public productClasses: Maybe<string[]>;

  @Field(() => String)
  public fundingPartnerID: Maybe<string>;

  protected getFilterArray() {
    const filter = this.toObject();
    const filterIDs = filter.ids?.length ? { _id: { $in: filter.ids } } : {};
    const filterPartnerIds = filter.partnerIds?.length ? { _id: { $in: filter.partnerIds } } : {};
    const filterProducts = this.getFilterAspect('produktClass')?.getMongoFilter() ?? {};

    return [filterIDs, filterPartnerIds, filterProducts];
  }

  override getMongoFilter(): Dictionary<any> {
    const filters = this.getFilterArray();
    const extendedFilter = super.getMongoFilter();

    if (extendedFilter.$and?.length) filters.push(extendedFilter);
    if (!filters.length) return {};
    return { $and: filters };
  }

  getZipCitiesFilter() {
    if (!this.zipCities?.length) return {};
    const or: Filter<KPF> = { $or: [] };

    this.zipCities.forEach(zipCity => {
      if (zipCity.zip) {
        (or.$or ?? []).push({
          'school.address.zipCity.zip': {
            $regex: zipCity.zip.replaceAll(/([^\w])/g, '\\$1'),
            $options: 'i',
          },
        });
      }

      if (zipCity.city) {
        (or.$or ?? []).push({
          'school.address.zipCity.city': {
            $regex: zipCity.city.replaceAll(/([^\w])/g, '\\$1'),
            $options: 'i',
          },
        });
      }
    });

    return or;
  }
}
